import React from 'react'
import styled from 'styled-components'
import { tryExtractPixelProperty } from '~/utils/css'

const CircleWrapper = styled.div`
  justify-content: center;
  align-items: center;
`

interface StyledCircleProps {
  $radius: number
  $color: string
  $margin?: string | number
}

const StyledCircle = styled.span<StyledCircleProps>`
  display: flex;
  width: ${(props) => props.$radius * 2}px;
  height: ${(props) => props.$radius * 2}px;
  border-radius: 50%;
  background-color: ${(props) => props.$color};
  margin: ${(props) => tryExtractPixelProperty(props.$margin)};
`
interface CircleProps {
  radius: number
  color: string
  margin?: string | number
}

const Circle = ({ radius, color, margin }: CircleProps) => {
  return (
    <CircleWrapper>
      <StyledCircle $radius={radius} $color={color} $margin={margin} />
    </CircleWrapper>
  )
}

export default Circle
